import React, { useState } from "react"
import Modal from '../index'
import FormGroupInline from "../../Form/FormGroupInline"
import FormGroup from "../../Form/FormGroup"
import Input from "../../Form/Input"
import Button from "../../Form/Button"
import { BsRobot } from "react-icons/bs"
import { useEffect } from "react"
import { FaPencilAlt } from "react-icons/fa"
import { getOptionByOptionList } from "../../../utils/utils"
import Select from "../../Form/Select"

const ModalAgent = ({ data = {}, optionsStatus = [], onSubmit = () => { }, closeModal = () => { } }) => {
    const [agent, setAgent] = useState(data)
    const [isNew, setIsNew] = useState(false)
    const [editable, setEditable] = useState(false)

    useEffect(() => {
        setIsNew(!data?._id)
    }, [data])

    useEffect(() => {
        if (isNew) {
            setEditable(true)
        }
    }, [isNew])

    const handleChangeValue = (name, value) => {
        setAgent(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        if (isNew) {
            closeModal()
        } else {
            setEditable(false)
        }
    }

    const handleSave = (e) => {
        e?.preventDefault()
        const dataAgent = isNew ? agent : { ...agent, zaia_id: agent._id }
        onSubmit(dataAgent, isNew)
    }

    return (
        <Modal
            icon={<BsRobot />}
            title={isNew ? "Cadastro de novo agente" : (editable ? "Editando agente" : "Visualizando agente")}
            description={isNew || editable ? "Preencha os campos abaixo e clique em salvar" : "Para editar as informações clique no ícone de edição"}
            closeModal={closeModal}
        >
            <form onSubmit={handleSave}>
                <FormGroupInline>
                    <FormGroup labelText="Nome do agente">
                        {editable ?
                            <Input type="text" placeholder="Nome do agente" value={agent.name ?? ""} onChange={(e) => handleChangeValue("name", e.target.value)} />
                            :
                            <span>{agent.name}</span>
                        }
                    </FormGroup>
                    {!editable &&
                        <Button variant="secondary" className="action" onClick={() => setEditable(true)}>
                            <FaPencilAlt />
                        </Button>
                    }
                </FormGroupInline>
                <FormGroup labelText="ID do agente">
                    {editable ?
                        <Input type="text" placeholder="ID do agente" value={agent.agent_id ?? ""} onChange={(e) => handleChangeValue("agent_id", e.target.value)} />
                        :
                        <span>{agent.agent_id}</span>
                    }
                </FormGroup>
                <FormGroup labelText="ID da etapa de transferência">
                    {editable ?
                        <Input type="text" placeholder="ID da etapa de transferência" value={agent.zaia_transfer_stage_id ?? ""} onChange={(e) => handleChangeValue("zaia_transfer_stage_id", e.target.value)} />
                        :
                        <span>{agent.zaia_transfer_stage_id}</span>
                    }
                </FormGroup>
                <FormGroup labelText="Status">
                    {editable ?
                        <Select multiple={false} name="Status" placeholder="Buscar..." options={optionsStatus} onChange={(value) => handleChangeValue("status", value)} selected={agent.status ?? ""} />
                        :
                        <span>{getOptionByOptionList(agent.status, optionsStatus)}</span>
                    }
                </FormGroup>
                {isNew &&
                    <FormGroup labelText="Token de acesso">
                        <Input type="text" placeholder="Token de acesso" value={agent.access_token ?? ""} onChange={(e) => handleChangeValue("access_token", e.target.value)} />
                    </FormGroup>
                }
                {editable &&
                    <FormGroupInline>
                        <Button variant='primary' type="submit">Salvar</Button>
                        <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                    </FormGroupInline>
                }
            </form>
        </Modal>
    )
}

export default ModalAgent
